export const ZT_0001 = 'default_pc_pc_home_top_series'
export const ZT_0002 = 'default_pc_pc_search_series_card'
export const ZT_0003 =
  'dcd_pc_page_search_result_new_car_style_list_ask_floor_price'
export const ZT_0004 = 'default_pc_pc_search_suggest_series_card'
export const ZT_0005 =
  'dcd_pc_page_search_result_new_find_car_list_ask_floor_price'
export const ZT_0006 =
  'dcd_pc_page_personal_homepage_follow_car_style_ask_floor_price'
export const ZT_0007 = 'dcd_pc_page_ugc_detail_bottom_ask_floor_price'
export const ZT_0008 =
  'dcd_pc_page_feed_article_mix_video_relevant_car_series_ask_floor_price'
export const ZT_0009 =
  'dcd_pc_page_feed_article_mix_video_recommend_car_series_ask_floor_price'
export const ZT_0010 =
  'dcd_pc_page_feed_article_mix_article_relevant_car_series_ask_floor_price'
export const ZT_0011 =
  'dcd_pc_page_feed_article_mix_article_recommend_car_series_ask_floor_price'
export const ZT_0012 =
  'dcd_pc_page_feed_article_mix_article_words_guide_ask_floor_price'
export const ZT_0013 =
  'dcd_pc_page_pgc_article_detail_relate_car_series_ask_floor_price'
export const ZT_0014 =
  'dcd_pc_page_pgc_article_detail_words_guide_ask_floor_price'
export const ZT_0015 =
  'dcd_pc_page_pgc_article_detail_car_series_picture_ask_floor_price'
export const ZT_0016 =
  'dcd_pc_page_pgc_article_detail_recommend_car_series_ask_floor_price'
export const ZT_0017 =
  'dcd_pc_page_pgc_video_detail_relevant_car_series_ask_floor_price'
export const ZT_0018 =
  'dcd_pc_page_pgc_video_detail_recommend_car_series_ask_floor_price'
export const ZT_0019 =
  'dcd_pc_page_car_series_pc_car_style_list_ask_floor_price'
export const ZT_0020 = 'default_pc_pc_series_top_title'
export const ZT_0021 = 'default_pc_pc_article_related_series'
export const ZT_0022 = 'default_pc_pc_series_car_list'
export const ZT_0023 =
  'dcd_pc_page_car_series_home_recommend_car_series_ask_floor_price'
export const ZT_0024 = 'dcd_pc_car_series_page_dealer_list_free_consultation'
export const ZT_0025 =
  'dcd_pc_page_series_real_picture_up_right_corner_ask_floor_price'
export const ZT_0026 =
  'dcd_pc_page_series_real_picture_tab_below_ask_floor_price'
export const ZT_0027 =
  'dcd_pc_page_series_picture_detail_picture_right_ask_floor_price'
export const ZT_0028 = 'default_pc_pc_series_top_configuration'
export const ZT_0029 =
  'dcd_pc_page_car_series_dcd_score_home_recommend_car_series_ask_floor_price'
export const ZT_0030 =
  'dcd_pc_page_series_article_list_recommend_car_series_ask_floor_price'
export const ZT_0031 =
  'dcd_pc_page_series_video_list_recommend_car_series_ask_floor_price'
export const ZT_0032 =
  'dcd_pc_page_series_instruction_video_detail_relevant_car_series_ask_floor_price'
export const ZT_0033 = 'dcd_pc_page_series_inquiry_ask_floor_price'
export const ZT_0034 =
  'dcd_pc_page_car_model_comparison_parameter_contrast_ask_floor_price'
export const ZT_0035 =
  'dcd_pc_page_car_zonghe_comparison_market_quotation_ask_floor_price'
export const ZT_0036 = 'dcd_pc_buy_car_page_car_series_list_ask_floor_price'
export const ZT_0037 = 'dcd_pc_buy_car_pc_tag_car_series_ask_floor_price'
export const ZT_0038 = 'dcd_pc_buy_car_pc_tag_car_series_list_ask_floor_price'
export const ZT_0039 = 'dcd_pc_page_car_style_home_dealer_free_consult_service'
export const ZT_0040 =
  'dcd_pc_page_car_style_home_choice_used_car_module_used_car_card'
export const ZT_0041 =
  'dcd_pc_page_car_style_home_basic_information_ask_floor_price'
export const ZT_0042 = 'dcd_pc_page_car_style_home_basic_information_used_car'
export const ZT_0043 = 'default_pc_pc_search_brand_series_card'
export const ZT_0044 = 'dcd_pc_page_car_style_home_car_owner_price'
export const ZT_0045 =
  'dcd_pc_page_feed_pgc_article_detail_car_series_picture_ask_floor_price'
export const ZT_0046 = 'dcd_pc_page_reputation_detail_bottom_ask_floor_price'
export const ZT_0047 =
  'dcd_pc_page_price_calculator_full_payment_ask_floor_price'
export const ZT_0048 = 'dcd_pc_page_price_calculator_loan_ask_floor_price'
export const ZT_0049 = 'dcd_pc_zt_new_car_dcd_list_sale_list_car_card_inquery'
export const ZT_0050 = 'dcd_pc_zt_new_car_dcd_list_hot_list_car_card_inquery'
export const ZT_0051 =
  'dcd_pc_zt_new_car_dcd_list_city_list_hot_sale_list_car_card_inquery'
export const ZT_0052 =
  'dcd_pc_zt_new_car_dcd_list_city_list_price_cut_list_car_card_inquery'
export const ZT_0053 = 'dcd_pc_zt_esc_c2_used_car_source_detail_view_staging'
export const ZT_0054 = 'dcd_pc_zt_esc_c2_used_car_source_detail_staging_buy_car'
export const ZT_0055 = 'dcd_pc_zt_esc_c2_used_car_source_detail_view_phone_num'
export const ZT_0056 =
  'dcd_pc_zt_esc_c2_used_car_source_detail_car_condition_consultation'

export const agent = {
  orderDrive: 'dcd_pc_zt_page_dealer_detail_book_test_drive',
  inquery: 'dcd_pc_zt_page_dealer_detail_inquery',
}

export const configuration = {
  inquery: 'dcd_pc_page_series_configuration_configuration_content_inquery',
}

export const imageList = {
  inquery: 'dcd_pc_page_series_real_picture_tab_below_ask_floor_price',
}

export const imageDetail = {
  inquery: 'dcd_pc_page_series_picture_detail_picture_right_ask_floor_price',
}

export const inquiry = {
  coupon: 'dcd_pc_page_series_inquiry_success_ticket_card',
  recommendSeries:
    'dcd_pc_page_series_inquiry_success_equival_car_recommend_inquiry_order',
  dealer: 'dcd_pc_page_series_inquiry_dealer_card',
}
export const library = {
  inquiry: 'dcd_pc_page_car_series_pc_car_style_list_ask_floor_price',
  brandHotSeries: 'dcd_pc_page_car_series_pc_car_brand_list_ask_floor_price',
}

export const configDetail = {
  inquiry: 'dcd_pc_page_tensofmillions_car_parameter_ask_floor_price',
  loan: 'dcd_pc_page_tensofmillions_car_parameter_buy_car_staging_btn',
  seriesCardInquiry:
    'dcd_pc_page_tensofmillions_car_parameter_car_series_card_ask_floor_price',
}

export const sales = {
  score: 'dcd_pc_zt_new_car_dcd_list_dc_score_list_car_card_inquery',
  energy: 'dcd_pc_zt_new_car_dcd_list_new_energy_car_card_inquery',
  test: 'dcd_pc_zt_new_car_dcd_list_measured_list_car_card_inquery',
}
